"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterComponent = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var constants_1 = require("../constants"); // https://itnext.io/responsive-background-images-using-react-hooks-941af365ea1f


var FooterComponent = function FooterComponent(_a) {
  var theme = _a.theme;
  var iconSize = (0, basic_frontend_common_1.isMobileView)(constants_1.MOBILE_VIEW_WIDTH) ? basic_frontend_common_1.IconSize.xxs : basic_frontend_common_1.IconSize.xs;
  var year = new Date().getFullYear();
  return react_1["default"].createElement(basic_frontend_common_1.Footer, {
    theme: theme
  }, react_1["default"].createElement("ul", {
    className: "flex flex-row mt-4 md:mt-6 mb-1 md:mb-2"
  }, react_1["default"].createElement("li", {
    className: "ml-2 mr-2 md:ml-4 md:mr-4"
  }, react_1["default"].createElement(basic_frontend_common_1.Link, {
    href: "https://github.com/responsive-kaysta",
    theme: theme,
    newWindow: true
  }, react_1["default"].createElement(basic_frontend_common_1.Icon, {
    name: "github_logo",
    size: iconSize
  }))), react_1["default"].createElement("li", {
    className: "ml-2 mr-2 md:ml-4 md:mr-4"
  }, react_1["default"].createElement(basic_frontend_common_1.Link, {
    href: "https://www.xing.com/profile/Kay_Stuckenschmidt/cv",
    theme: theme,
    newWindow: true
  }, react_1["default"].createElement(basic_frontend_common_1.Icon, {
    name: "xing_logo",
    size: iconSize
  }))), react_1["default"].createElement("li", {
    className: "ml-2 mr-2 md:ml-4 md:mr-4"
  }, react_1["default"].createElement(basic_frontend_common_1.Link, {
    href: "https://www.linkedin.com/in/responsivekaysta/",
    theme: theme,
    newWindow: true
  }, react_1["default"].createElement(basic_frontend_common_1.Icon, {
    name: "linkedin_logo",
    size: iconSize
  })))), react_1["default"].createElement("span", {
    className: "mb-1 md:mb-2"
  }, react_1["default"].createElement(basic_frontend_common_1.Link, {
    href: "https://responsive-it.biz",
    theme: theme,
    newWindow: true
  }, year, " - ", constants_1.PAGE_AUTHOR)), react_1["default"].createElement("span", {
    className: "mb-1 md:mb-2"
  }, constants_1.APP_VERSION));
};

exports.FooterComponent = FooterComponent;